import React from "react";
import * as L from "leaflet";
//STYLE IMPORT
import "rsuite/dist/styles/rsuite-default.css";
import "leaflet-easybutton";
import "leaflet-easybutton/src/easy-button.css";
import { isIOS, isAndroid, isSafari } from "react-device-detect";
import { withRouter } from "react-router-dom";
import qs from "query-string";

//CUSTOM IMPORT
import PinMarker from "../../assets/icons/mylocation.png";
import cars from "../../assets/icons/car_list_unselected.png";
import settings from "../../assets/icons/cars_setting_unselected.png";
import carStatus from "../../assets/icons/car_status_unselected.png";
import reportIcon from "../../assets/icons/car_report_unselected.png";
import Sign from "../../assets/icons/ramz.png";
import "leaflet-draw";
import LiveIcon from "../../assets/icons/show_map_unselected.png";
import LiveSelectedIcon from "../../assets/icons/show_map_selected.png";
import ReportSelected from "../../assets/icons/car_report_selected.png";
import SelectedSetting from "../../assets/icons/cars_setting_selected.png";
import SelectedStatus from "../../assets/icons/car_status_selected.png";
import SelectedListCar from "../../assets/icons/car_list_selected.png";

//REDUX IMPORT
import { connect } from "react-redux";
import {
	SetMap,
	SetIconsLayer,
	SetMountLiveTime,
} from "../../redux/map/map.actions";
import {
	GetCarsData,
	GetReports,
	SelectedCar,
	SetIcons,
	SetInterval,
	SetReportIndex,
} from "../../redux/cars/cars.action";
import { createStructuredSelector } from "reselect";
import {
	selectAllDeviceInfo,
	selectCarIcons,
	selectCarsData,
	selectHoldOverCars,
	selectImei,
	selectInterval,
	selectIsWithOutPoint,
	selectReports,
	selectSelectedCarInfo,
	selectSingleCarData,
} from "../../redux/cars/cars.selector";
import CarsModal from "../../components/cars.modal/cars.modal";
import "leaflet-rotatedmarker";
import "leaflet-realtime";
import modalsTypes from "../../redux/modals/modals.types";
import {
	selectIconsLayer,
	selectIsLive,
	selectIsMain,
	selectMap,
	selectMyLocationArr,
	selectReportLayer,
} from "../../redux/map/map.selector";
import mapTypes from "../../redux/map/map.types";
import ChangePassComponent from "../../components/changePass.modal/changePass.component";
import SettingModal from "../../components/setting.modal/setting.modal";
import SignInComponent from "../../components/signIn.modal/signIn.component";
import {
	selectFirstCheck,
	selectToken,
	selectUserInfo,
} from "../../redux/user/user.selector";
import StatusComponent from "../../components/status.modal/status.component";
import ReportsComponent from "../../components/reports.modal/reports.component";
import HoldoverDrawer from "../../components/holdover.drawer/holdover.drawer";
import { antPath } from "leaflet-ant-path";
import CarsLayer from "../../components/cars.layer/cars.layer";
import LiveComponent from "../../components/showLive/live.component";
// import {SelectPicker} from "rsuite";

import "./map.style.sass";
import {
	selectChangePassModal,
	selectIconModal,
	selectInitModal,
	selectReportsModal,
	selectSignModal,
	selectStatusModal,
	selectToggleSettingModal,
} from "../../redux/modals/modals.selector";
import {
	SetIosAndroid,
	SetToken,
	SetUser,
} from "../../redux/user/user.actions";
import { Alert } from "rsuite";
import AndroidIosModal from "../../components/android-ios.modal/android-ios.modal";
import UserTypes from "../../redux/user/user.types";
import Axios from "axios";
// import PaymentComponent from "../../components/payment.modal/payment.component";
// import {selectToggleSuccess} from "../../redux/modals/modals.selector";

//IN THE NAME OF GOD
class MapSearch extends React.Component {
	//COMPONENT DID MOUNT
	componentDidMount() {
		this.handleFetch();
		const {
			setMap,
			UseFirstLocation,
			myLocationArr,
			ToggleIsMain,
			setUser,
			getToken,
			ToggleInitModal,
			FirstCheck,
			setAndroidIos,
			SeePwaInfo,
			history,
			isMain,
			getUser,
			setToken,
		} = this.props;
		if (history.location.search && !getUser) {
			const ghostData = qs.parse(history.location.search);
			const data = {
				phone: ghostData.phone,
				pass: ghostData.pass,
			};
			Axios.post("https://xitonix.com/api/login", JSON.stringify(data)).then(
				(res) => {
					if (res.data.success === "true") {
						setToken(res.data.data.Server);
						setUser(data);
						if (!isMain) {
							ToggleIsMain();
						}
						Alert.success("به دموی پنل ردیابی خوش آمدید.", 3000);
					} else {
						Alert.error(
							"ورود به دموی پنل ردیابی با مشکل مواجه شد لطفا بعدا مجددا تلاش کنید."
						);
					}
				}
			);
		}
		if (FirstCheck && isAndroid) {
			setAndroidIos("android");
			ToggleInitModal();
			SeePwaInfo();
		}
		if (FirstCheck && isIOS) {
			setAndroidIos("ios");
			ToggleInitModal();
			SeePwaInfo();
		}
		if (!getToken) {
			setUser(null);
		}
		//MAP BASE LAYERS
		const firstmap = L.tileLayer(
				"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
				{
					maxZoom: 19,
					attribution:
						'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				}
			),
			TopoMap = L.tileLayer(
				"https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
				{
					maxZoom: 17,
					attribution:
						'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
				}
			),
			SmoothDark = L.tileLayer(
				"https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=2cc70d23-885a-4d58-b917-4e0e719a9e2a",
				{
					maxZoom: 20,
					attribution:
						'&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
				}
			),
			Secoundmap = L.tileLayer(
				"https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png",
				{
					maxZoom: 18,
					attribution:
						'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				}
			),
			TreeMap = L.tileLayer(
				"https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png",
				{
					maxZoom: 20,
					attribution:
						'&copy; Openstreetmap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				}
			),
			a = L.tileLayer("https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png", {
				maxZoom: 19,
				attribution:
					'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>',
			}),
			y = L.tileLayer(
				"https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=2cc70d23-885a-4d58-b917-4e0e719a9e2a",
				{
					maxZoom: 19,
					attribution:
						'&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
				}
			);

		const baseMaps = {
			"پیش‌ فرض": firstmap,
			شب: SmoothDark,
			روشن: y,
			توپوگرافی: TopoMap,
			Humanitarian: a,
			"بلوار قرمز": Secoundmap,
		};

		//MAP CREATION
		let map = L.map("mapsearch", {
			center: [32.951302, 53.652285],
			// tapTolerance: 25,
			tap: false,
			zoom: 5,
			maxZoom: 18,
			zoomControl: false,
			layers: [firstmap],
		});

		L.control.layers(baseMaps).addTo(map);

		new L.Control.Zoom({ position: "bottomright" }).addTo(map);

		/** DeBug IOS ICON */

		//FIND MY LOCATION EASY BUTTON
		L.easyButton(
			`<img src=${PinMarker} alt="My location" class="img-easy-button"/>`,
			() => {
				map.locate().on("locationfound", (e) => {
					const thisMarker = L.marker([e.latitude, e.longitude]);
					if (myLocationArr.length === 0) {
						thisMarker.addTo(map);
						map.flyTo([e.latitude, e.longitude], 13);
						UseFirstLocation();
						// SetIconsLayer(thisMarker);
					} else {
						thisMarker.setLatLng([e.latitude, e.longitude]);
						map.flyTo([e.latitude, e.longitude], 13);
					}
				});
			},
			"Search Current Results within drawn layers",
			{ position: "topright" }
		).addTo(map);

		setMap(map);
		ToggleIsMain();
	}

	handleFetch = async () => {
		try {
			const data = await Axios.get("https://admin.xitonix.com/api/chat/code");
			console.log(data.data.code);
			const newCode = data.data.code.slice(31, -9);

			const s = document.createElement("script");
			s.type = "text/javascript";
			s.async = true;
			s.innerHTML = newCode;
			this.instance.appendChild(s);
		} catch (error) {
			console.log(error);
		}
	};

	render() {
		const {
			ToggleCarsModal,
			ToggleReportsModal,
			ToggleChangePass,
			ToggleSettingModal,
			selectedCarNow,
			SetMountLiveTime,
			ToggleSignModal,
			selectUser,
			ToggleStatusModal,
			holdoverCars,
			isLive,
			isMain,
			ToggleIsLive,
			ToggleIsMain,
			getReports,
			reportsModal,
			settingModal,
			carStatusModal,
			carsModal,
			changePassModal,
			getAllDeviceInfo,
			ToggleInitModal,
			selectSingleCar,
			signInModal,
			CarsData,
			IsWithOutPoint,
		} = this.props;

		const handleShowLive = () => {
			if (isMain) {
				ToggleIsMain();
			}
			if (!isLive) {
				ToggleIsLive();
			}
		};

		return (
			<div className="custom-container">
				<div id="mapsearch" />
				<div className="bottom-controler">
					<div className="copy-right-area">
						<p>کلیه حقوق برای زیتونیکس محفوظ است.</p>
					</div>
					<div className="detail-area">
						<div className="detail-row">
							{selectUser ? (
								selectedCarNow ? (
									<div>
										<button onClick={() => ToggleSettingModal()}>
											<img
												src={settingModal ? SelectedSetting : settings}
												alt="cars"
											/>
											<br />
											<span>تنظیمات دستگاه</span>
										</button>
										<button onClick={() => ToggleStatusModal()}>
											<img
												src={carStatusModal ? SelectedStatus : carStatus}
												alt="cars"
											/>
											<br />
											<span>وضعیت</span>
										</button>
										<button onClick={() => ToggleReportsModal()}>
											<img
												src={
													getReports.length || reportsModal
														? ReportSelected
														: reportIcon
												}
												alt="cars"
											/>
											<br />
											<span>گزارش گیری</span>
										</button>
										<button
											id="LIVE"
											onClick={() => handleShowLive()}
										>
											<img
												src={isLive ? LiveSelectedIcon : LiveIcon}
												alt="cars"
											/>
											<br />
											<span>نمایش زنده</span>
										</button>
										<button onClick={() => ToggleCarsModal()}>
											<img
												src={carsModal ? SelectedListCar : cars}
												alt="cars"
											/>
											<br />
											<span>دستگاه ها</span>
										</button>
									</div>
								) : CarsData.length ? (
									<div>
										<button onClick={() => ToggleChangePass()}>
											<img
												src={changePassModal ? SelectedSetting : settings}
												alt="setting"
											/>
											<br />
											<span>تنظیمات کاربری</span>
										</button>
										<button onClick={() => ToggleCarsModal()}>
											<img
												src={carsModal ? SelectedListCar : cars}
												alt="cars"
											/>
											<br />
											<span>دستگاه ها</span>
										</button>
										<a
											href="https://newgps.xitonix.com/"
											className="update-area"
										>
											<img
												src="/update.svg"
												alt="Update"
												height={25}
											/>
											<span>نسخه جدید</span>
										</a>
									</div>
								) : (
									<div>
										<button onClick={() => ToggleChangePass()}>
											<img
												src={changePassModal ? SelectedSetting : settings}
												alt="setting"
											/>
											<br />
											<span>تنظیمات کاربری</span>
										</button>
										<button
											onClick={() => Alert.error("شما دستگاهی ثبت نکرده اید")}
										>
											<img
												src={carsModal ? SelectedListCar : cars}
												alt="cars"
											/>
											<br />
											<span>دستگاه ها</span>
										</button>
										<a
											href="https://newgps.xitonix.com/"
											className="update-area"
										>
											<img
												src="/update.svg"
												alt="Update"
												height={25}
											/>
											<span>نسخه جدید</span>
										</a>
									</div>
								)
							) : (
								<>
									<button onClick={() => ToggleSignModal()}>
										<img
											src={Sign}
											alt="cars"
										/>
										<br />
										<span>ورود</span>
									</button>
									<a
										href="https://newgps.xitonix.com/"
										className="update-area"
									>
										<img
											src="/update.svg"
											alt="Update"
											height={25}
										/>
										<span>نسخه جدید</span>
									</a>
								</>
							)}
						</div>
					</div>
				</div>

				{/*LAYERS*/}
				{selectUser ? isMain ? <CarsLayer /> : null : null}
				{isLive ? <LiveComponent /> : null}
				{/* MODALS */}
				{selectUser ? getAllDeviceInfo ? <CarsModal /> : null : null}
				<ChangePassComponent />
				{selectedCarNow ? <SettingModal /> : null}
				{signInModal ? <SignInComponent /> : null}
				{(selectedCarNow && selectSingleCar) || IsWithOutPoint ? (
					<StatusComponent />
				) : null}
				{selectedCarNow ? <ReportsComponent /> : null}
				<AndroidIosModal />
				{/*DRAWER*/}
				<HoldoverDrawer />
				{/*<PaymentComponent/>*/}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	setMap: (map) => dispatch(SetMap(map)),
	setCars: (cars) => dispatch(GetCarsData(cars)),
	selectedCar: (car) => dispatch(SelectedCar(car)),
	SetIconsLayer: (layer) => dispatch(SetIconsLayer(layer)),
	SetIcons: (icons) => dispatch(SetIcons(icons)),
	ToggleCarsModal: () => dispatch({ type: modalsTypes.TOGGLE_ICONS }),
	ToggleChangePass: () => dispatch({ type: modalsTypes.TOGGLE_CHANGE_PASS }),
	UseFirstLocation: () => dispatch({ type: mapTypes.MY_LOCATION }),
	ToggleSettingModal: () =>
		dispatch({ type: modalsTypes.TOGGLE_SETTING_MODAL }),
	ToggleSignModal: () => dispatch({ type: modalsTypes.TOGGLE_SIGN_MODAL }),
	ToggleStatusModal: () => dispatch({ type: modalsTypes.TOGGLE_STATUS_MODAL }),
	ToggleReportsModal: () =>
		dispatch({ type: modalsTypes.TOGGLE_REPORTS_MODAL }),
	SetInterval: (interval) => dispatch(SetInterval(interval)),
	SetReportIndex: (index) => dispatch(SetReportIndex(index)),
	ToggleIsMain: () => dispatch({ type: mapTypes.TOGGLE_IS_MAIN }),
	ToggleIsLive: () => dispatch({ type: mapTypes.TOGGLE_IS_LIVE }),
	SetMountLiveTime: (time) => dispatch(SetMountLiveTime(time)),
	setToken: (token) => dispatch(SetToken(token)),
	setUser: (data) => dispatch(SetUser(data)),
	ToggleInitModal: () => dispatch({ type: modalsTypes.TOGGLE_INIT_MODAL }),
	setAndroidIos: (deviceType) => dispatch(SetIosAndroid(deviceType)),
	SeePwaInfo: () => dispatch({ type: UserTypes.SEE_PWA_INFO }),
});
const mapStateToProps = createStructuredSelector({
	CarsData: selectCarsData,
	selectedCar: selectSelectedCarInfo,
	getMap: selectMap,
	myLocationArr: selectMyLocationArr,
	selectedCarNow: selectSelectedCarInfo,
	selectUser: selectUserInfo,
	selectReports: selectReports,
	getIconLayer: selectIconsLayer,
	getReportLayer: selectReportLayer,
	getUser: selectUserInfo,
	getIcon: selectCarIcons,
	getInterval: selectInterval,
	isLive: selectIsLive,
	isMain: selectIsMain,
	holdoverCars: selectHoldOverCars,
	getReports: selectReports,
	reportsModal: selectReportsModal,
	settingModal: selectToggleSettingModal,
	carStatusModal: selectStatusModal,
	carsModal: selectIconModal,
	changePassModal: selectChangePassModal,
	getToken: selectToken,
	getAllDeviceInfo: selectAllDeviceInfo,
	initModal: selectInitModal,
	signInModal: selectSignModal,
	FirstCheck: selectFirstCheck,
	selectSingleCar: selectSingleCarData,
	IsWithOutPoint: selectIsWithOutPoint,
});
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MapSearch)
);
